/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class SkeletonLoaderConstants {
}
SkeletonLoaderConstants.CONTENT_LOADER = 'content-loader';
SkeletonLoaderConstants.HEADER_LOADER = 'header-loader';
SkeletonLoaderConstants.NAVBAR_LOADER = 'navbar-loader';
SkeletonLoaderConstants.QUICKNAV_LOADER = 'quicknav-loader';
SkeletonLoaderConstants.FOOTER_LOADER = 'footer-loader';
SkeletonLoaderConstants.ALL_LOADER = [
    SkeletonLoaderConstants.HEADER_LOADER,
    SkeletonLoaderConstants.NAVBAR_LOADER,
    SkeletonLoaderConstants.QUICKNAV_LOADER,
    SkeletonLoaderConstants.CONTENT_LOADER,
    SkeletonLoaderConstants.FOOTER_LOADER
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2tlbGV0b24tbG9hZGVyLmNvbnN0YW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zaGFyZWQvc2l0ZS9sb2FkZXJzL3NrZWxldG9uLWxvYWRlci5jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sdUJBQXVCOztBQUNULHNDQUFjLEdBQUcsZ0JBQWdCLENBQUM7QUFDbEMscUNBQWEsR0FBRyxlQUFlLENBQUM7QUFDaEMscUNBQWEsR0FBRyxlQUFlLENBQUM7QUFDaEMsdUNBQWUsR0FBRyxpQkFBaUIsQ0FBQztBQUNwQyxxQ0FBYSxHQUFHLGVBQWUsQ0FBQztBQUVoQyxrQ0FBVSxHQUFHO0lBQ2hDLHVCQUF1QixDQUFDLGFBQWE7SUFDckMsdUJBQXVCLENBQUMsYUFBYTtJQUNyQyx1QkFBdUIsQ0FBQyxlQUFlO0lBQ3ZDLHVCQUF1QixDQUFDLGNBQWM7SUFDdEMsdUJBQXVCLENBQUMsYUFBYTtDQUN4QyxDQUFBIn0=